import React from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import ProtectedRoute from "components/ProtectedRoute"
import Admin from "pages/Admin"
import Login from "pages/Login"
import Register from "pages/Register"
import NotFound from "pages/NotFound"
import App from "pages/App"
import Onboarding from "pages/OnBoarding"
import SuperAdmin from "pages/SuperAdmin"
import OrganizationSignUp from "pages/OrganizationSignUp"
import Magic from "pages/Magic"
import NoOrganizationPage from "pages/NoOrganizationPage"
import TermsConditions from "pages/PrivacyTermsPages/TermsConditions"
import Copyright from "pages/PrivacyTermsPages/Copyright"
import PrivacyPolicy from "pages/PrivacyTermsPages/PrivacyPolicy"

export default ({ childProps }) => (
  <Switch>
    <Route path="/" exact component={() => <Redirect to="/login" />} />
    <Route path="/login" component={Login} />
    <Route path="/register" component={Register} />
    <ProtectedRoute
      exact
      component={() => <Redirect to="/admin/recentposts" />}
      path="/admin"
    />
    <ProtectedRoute
      exact
      component={() => <Redirect to="/app/feed" />}
      path="/app"
    />
    <ProtectedRoute component={Admin} path="/admin" />
    <ProtectedRoute component={App} path="/app" />
    <ProtectedRoute component={Onboarding} path="/onboarding" />
    <ProtectedRoute component={SuperAdmin} path="/superadmin" />
    <ProtectedRoute
      component={OrganizationSignUp}
      path="/signup"
      queryString="?skipOrg=true"
    />
    <ProtectedRoute
      exact
      path="/noorganizationpage"
      component={NoOrganizationPage}
    />
    <Route extact path="/termsandconditions" component={TermsConditions} />
    <Route extact path="/copyright" component={Copyright} />
    <Route extact path="/privacypolicy" component={PrivacyPolicy} />
    <Route path="/start/:magic/:id" component={Magic} />

    {/* Finally, catch all unmatched routes */}
    <Route component={NotFound} />
  </Switch>
)



// WEBPACK FOOTER //
// ./src/routes/index.jsx